import moment from 'moment';
import nl from 'moment/locale/nl';

moment.updateLocale('nl', nl);

export default moment;
